import React, { createContext, useState, useEffect } from 'react';

import jwt from 'jsonwebtoken';
import axios from 'axios';

import { 
	saveSession, 
	recoverSession, 
	deleteSession, 
	storeUserDataOnSessionStorage, 
	recoverUserDataFromSessionStorage, 
	deleteUserDataFromSessionStorage 
} from './utils/session';

export const AuthContext = createContext();

const Provider = ({ children }) => {

	const [isAuth, setIsAuth] = useState(() => {
		return recoverSession('token');
	});

	const [userData, setUserData] = useState(() => {
		return recoverUserDataFromSessionStorage();
	});

	useEffect(() => {
		let reqConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				'Access-Control-Allow-Origin': '*',
				'Authorization': `Bearer ${recoverSession('token')}`
			}
		};
		const tokenUrl = `${process.env.REACT_APP_BACKEND}/api/user/checkAuth`;
		axios.get(tokenUrl, reqConfig)
		.catch(err => {
			if (isAuth) {
				deleteSession();
				window.location.reload();
			}
		});
	}, []);

	const value = {
		isAuth,
		userData,
		activateAuth: (token) => {
			const decodedToken = jwt.decode(token) || {};
			// const userData = {
			// 	// email: decodedToken.email,
			// 	full_name: decodedToken.full_name,
			// 	// username: decodedToken.username,
			// 	user_type: decodedToken.user_type,
			// 	uid: decodedToken.uid,
			// 	first_name: decodedToken.first_name,
			// 	last_name: decodedToken.last_name
			// };
			const userData = decodedToken;
			storeUserDataOnSessionStorage(userData);
			setUserData(userData);
			saveSession('token', token);
			setIsAuth(true);
		},
		removeAuth: () => {
			setIsAuth(false);
			setUserData({});
			deleteUserDataFromSessionStorage();
			deleteSession();
		}
	};

	return (
		<AuthContext.Provider value={value}>
			{children}
		</AuthContext.Provider>
	);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { Provider, Consumer: AuthContext.Consumer };
